import { useEffect, useState } from "react"
import Styled from "./FooterStyled"

const ClientSideEnvInfo = () => {
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  return (
    <>
      {isClient && (
        <>
          <Styled.Note>
            {process.env.ENV}{" "}
            {process.env.BUILD_TIMESTAMP &&
              `- ${new Date(
                Number(process.env.BUILD_TIMESTAMP) * 1000 || "",
              ).toLocaleString()}`}
          </Styled.Note>
          <Styled.Note>Origin: {process.env.ORIGIN}</Styled.Note>
        </>
      )}
    </>
  )
}

export default ClientSideEnvInfo
